export default __webpack_public_path__ + "static/media/hero-img.065a4f29.svg";